import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hfc-terms-and-conditions-declined',
  templateUrl: './terms-and-conditions-declined.component.html',
  styleUrls: ['./terms-and-conditions-declined.component.scss']
})
export class TermsAndConditionsDeclinedComponent {}
